import { __decorate } from 'tslib';
import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { BehaviorSubject, merge, fromEvent } from 'rxjs';
import { map, first } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/layout';
let Viewport = class Viewport {
    constructor(
    // Dependencies
    breakpointObserver, 
    // Exposes
    mediaMatcher) {
        this.breakpointObserver = breakpointObserver;
        this.mediaMatcher = mediaMatcher;
        // Current values
        this.width$ = new BehaviorSubject(0); // Viewport width, with scrollbars
        this.height$ = new BehaviorSubject(0); // Viewport height, with scrollbars
        this.clientWidth$ = new BehaviorSubject(0); // Viewport width, without scrollbars
        this.clientHeight$ = new BehaviorSubject(0); // Viewport height, without scrollbars
        // Breakpoints
        this.smallDesktopMediaQuery = '(max-width: 1280px)';
        this.tabletMediaQuery = '(max-width: 960px)';
        this.phoneMediaQuery = '(max-width: 600px)';
        this.smallDesktop$ = new BehaviorSubject(false);
        this.tablet$ = new BehaviorSubject(false);
        this.phone$ = new BehaviorSubject(false);
        this.initializeBreakPoints();
        this.updateDimensions();
        this.initializeResizeHandler();
    }
    initializeBreakPoints() {
        this.breakpointObserver.observe(this.smallDesktopMediaQuery)
            .subscribe((state) => this.smallDesktop$.next(state.matches));
        this.breakpointObserver.observe(this.tabletMediaQuery)
            .subscribe((state) => this.tablet$.next(state.matches));
        this.breakpointObserver.observe(this.phoneMediaQuery)
            .subscribe((state) => this.phone$.next(state.matches));
    }
    updateDimensions() {
        this.width$.next(Math.max(document.documentElement.clientWidth, window.innerWidth || 0));
        this.height$.next(Math.max(document.documentElement.clientHeight, window.innerHeight || 0));
        this.clientWidth$.next(document.documentElement.clientWidth);
        this.clientHeight$.next(document.documentElement.clientHeight);
    }
    initializeResizeHandler() {
        merge(fromEvent(window, 'resize'), fromEvent(window, 'orientationchange')).subscribe(() => this.updateDimensions());
    }
    matches$(mediaQuery) {
        return this.breakpointObserver.observe(mediaQuery).pipe(map(state => state.matches));
    }
    matches(mediaQuery) {
        let matches;
        this.breakpointObserver.observe(mediaQuery).pipe(map(state => state.matches), first()).subscribe(m => { matches = m; });
        return matches;
    }
};
Viewport.ɵfac = function Viewport_Factory(t) { return new (t || Viewport)(ɵngcc0.ɵɵinject(ɵngcc1.BreakpointObserver), ɵngcc0.ɵɵinject(ɵngcc1.MediaMatcher)); };
Viewport.ctorParameters = () => [
    { type: BreakpointObserver },
    { type: MediaMatcher }
];
Viewport.ɵprov = ɵɵdefineInjectable({ factory: function Viewport_Factory() { return new Viewport(ɵɵinject(BreakpointObserver), ɵɵinject(MediaMatcher)); }, token: Viewport, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Viewport, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.BreakpointObserver }, { type: ɵngcc1.MediaMatcher }]; }, null); })();

/*
 * Public API Surface of angular-viewport
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Viewport };

